export default {
  '成绩查询列表':'成績查詢列表',
  '计划':'計劃',
  '请选择计划':'請選擇計劃',
  '查看成绩单':'查看成績單',
  '生成成绩单':'生成成績單',
  '学生':'學生',
}